import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { DEFAULT_LANGUAGE } from '../constants/constants';
import translationItalian from './Italian/translation.json';
import translationIt from './Italian/translation_NEW.json';
import translationItCandidate from './Italian/translation_candidate.json';
import translationItMotivation from './Italian/translation_motivation.json';
import translationItSoftSkill from './Italian/translation_soft_skill.json';
import translationItCompany from './Italian/translation_company.json';
import translationEn from './English/translation.json';
import translationEnCandidate from './English/translation_candidate.json';
import translationEnMotivation from './English/translation_motivation.json';
import translationEnSoftSkill from './English/translation_soft_skill.json';
import translationEnCompany from './English/translation_company.json';
import Backend from 'i18next-http-backend/esm';

const itMerged = {
	...translationItalian,
	...translationIt,
	...translationItCandidate,
	...translationItMotivation,
	...translationItSoftSkill,
	...translationItCompany,
};
const enMerged = {
	...translationEn,
	...translationEnCandidate,
	...translationEnMotivation,
	...translationEnSoftSkill,
	...translationEnCompany
};

const resources = {
	'it-It': {
		translation: itMerged,
	},
	it: {
		translation: itMerged,
	},
	en: {
		translation: enMerged,
	},
};

i18next
	.use(Backend)
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources,
		debug: false,
		interpolation: {
			escapeValue: false,
		},
		react: {
			useSuspense: true,
		},
		fallbackLng: DEFAULT_LANGUAGE,
	});
